import React, {Fragment,Component,useState,useEffect} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import Iframe from "react-iframe"
import { Redirect,Link } from 'react-router-dom';
import { Table,Placeholder } from 'semantic-ui-react';
import {
  Menu,
  Segment,
  Container,
  Divider,
  Message,
  Icon,
  Header,
  Dimmer,
  Responsive,
  Modal,
  Button,
  Image,
  Loader,
  Tab,
  Label
} from 'semantic-ui-react';
import {Base64} from 'js-base64';
import Clipboard from 'react-clipboard.js';

function Guide(props){

  const [synchronized, setSynchronized] = useState(true);
  const [current, setCurrent] = useState(0);

  useEffect(() => {

    axios.request("/common/time",{
      method:"GET",
      headers:{
        'Content-Type': 'application/json'
      }
    }).then(async (res)=>{

      setCurrent(new Date(res.data.time).toLocaleString());

      if(Math.abs(res.data.time - new Date().getTime()) < 2 * 60 * 1000 ){
        setSynchronized(true);
      }else{
        setSynchronized(false);
      }

    })

    return ()=>{ }

  }, []);

  const {t}       = props;
  const mobile    = /Android|iPhone|iPod/.test(navigator.userAgent);
  const title     = props.data.title;
  const port      = props.data.port;
  const password  = props.data.password;
  const code      = props.data.code;
  const hashed    = props.data.hashed;
  const user_id   = props.data.user_id;
  const user_vip  = props.data.user_vip;

  var subscribe_endpoint = "update.glados-config.com";
  //subscribe_endpoint = "update.glados-config.net";
  //subscribe_endpoint = "update.glados-config.org";

  const suburl           = `https://${subscribe_endpoint}/v2ray/${user_id}/${hashed}`
  const suburl_netch     = `https://${subscribe_endpoint}/netch/${user_id}/${hashed}`
  const [url,setURL] = useState(false);

  if(url){
    return <Redirect to={url}/>
  }

  const not_supported = <Fragment>
        <Segment placeholder>
          <Header icon>
            <Icon name='cloud upload' />
            <p>V2Ray 配置仅为 Basic/Pro/Team/Enterprise 用户提供</p>
          </Header>
          <Link to="/console/shop">
            <Button primary>升级</Button>
          </Link>
        </Segment>
  </Fragment>

  const [clipboard,setClipboard] = useState(false);
  const base = 10;

  return (
  <Fragment>

    <Header as='h2' color="blue">
      {t("settings.v2ray.title")}
      <Header.Subheader>
      {t("settings.v2ray.notes")}
      </Header.Subheader>
    </Header>

    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan='3'>
            Clients
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        <Segment>

              <Tab menu={{ color:"blue", secondary: true}} panes={[
                {
                  menuItem:<Menu.Item key='pro33'>V2Ray GUI</Menu.Item>,
                  render: () => {
                    return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>

                      <Message id="m4" info style={{boxShadow:"none"}}>
                        <Message.Header>V2Ray 客户端有限支持提示</Message.Header>
                        <p>由于 V2Ray 无法导入大部分节点，我们推荐您使用Clash</p>
                      </Message>

                      {user_vip>base?
                      <Fragment>

                        <p>1. 安装 V2RayN <a href="https://github.com/2dust/v2rayN/releases">下载地址</a></p>
                        <p>2. 复制配置文件URL:<Label>{suburl}</Label></p>
                        <p>3. 在 V2RayN 里添加订阅</p>

                        <p>V2Ray 客户端使用复杂，如果您使用 V2Ray 遇到任何故障或者其他问题，请使用更简单好用的<Link to="/console/clash"> Clash</Link> 客户端代替。</p>

                      </Fragment>
                          :not_supported }

                        </Tab.Pane>)
                  }
                },
                {
                  menuItem:<Menu.Item key='pro33'>More</Menu.Item>,
                  render: () => {
                    return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
                      {user_vip>base?
                      <Fragment>
                        <p>不推荐用户安装其他客户端，如果正在使用其他客户端，可以使用统一的配置文件:</p>
                        <p>统一的配置文件URL:<Label>{suburl}</Label></p>
                      </Fragment>
                          :not_supported }
                        </Tab.Pane>)
                  }
                }
              ]} />
        </Segment>
      </Table.Body>
    </Table>

  </Fragment>
  )
}
export {Guide};
